// extracted by mini-css-extract-plugin
export default {"successHeader":"successHeader-9fdb"};